import {
  OPT_WORKFLOWS_LIST_TYPE_ABANDONED_CART,
  OPT_WORKFLOWS_LIST_TYPE_ABANDONED_CART__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_ALL,
  OPT_WORKFLOWS_LIST_TYPE_ALL__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_BIRTHDAY,
  OPT_WORKFLOWS_LIST_TYPE_BIRTHDAY__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_EVENT,
  OPT_WORKFLOWS_LIST_TYPE_EVENT__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_EVENT_REMINDERS,
  OPT_WORKFLOWS_LIST_TYPE_EVENT_REMINDERS__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_FIELD_CONDITION,
  OPT_WORKFLOWS_LIST_TYPE_FIELD_CONDITION__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_GROUP_CONDITION,
  OPT_WORKFLOWS_LIST_TYPE_GROUP_CONDITION__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_ONBOARDING,
  OPT_WORKFLOWS_LIST_TYPE_ONBOARDING__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_RECIPIENT_ACTIVITY,
  OPT_WORKFLOWS_LIST_TYPE_RECIPIENT_ACTIVITY__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_SUBSCRIPTION_DATE,
  OPT_WORKFLOWS_LIST_TYPE_SUBSCRIPTION_DATE__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_THANKS_FOR_JOIN,
  OPT_WORKFLOWS_LIST_TYPE_THANKS_FOR_JOIN__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN,
  OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES,
  OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES__VALUE
} from 'Constants/'
import { Select } from 'mailup-web-components'
import { searchState } from 'Pages/WorkflowsList/recoil/state/search'
import PropTypes from 'prop-types'
import { useRef } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'

export const InputType = ({ onChange }) => {
  const intl = useIntl()
  const [{ type }, setSearchParams] = useRecoilState(searchState)
  const { current: options } = useRef([
    {
      label: intl.formatMessage({ id: OPT_WORKFLOWS_LIST_TYPE_ALL }),
      value: OPT_WORKFLOWS_LIST_TYPE_ALL__VALUE
    },
    {
      label: intl.formatMessage({ id: OPT_WORKFLOWS_LIST_TYPE_EVENT }),
      value: OPT_WORKFLOWS_LIST_TYPE_EVENT__VALUE
    },
    {
      label: intl.formatMessage({
        id: OPT_WORKFLOWS_LIST_TYPE_SUBSCRIPTION_DATE
      }),
      value: OPT_WORKFLOWS_LIST_TYPE_SUBSCRIPTION_DATE__VALUE
    },
    {
      label: intl.formatMessage({
        id: OPT_WORKFLOWS_LIST_TYPE_FIELD_CONDITION
      }),
      value: OPT_WORKFLOWS_LIST_TYPE_FIELD_CONDITION__VALUE
    },
    {
      label: intl.formatMessage({
        id: OPT_WORKFLOWS_LIST_TYPE_GROUP_CONDITION
      }),
      value: OPT_WORKFLOWS_LIST_TYPE_GROUP_CONDITION__VALUE
    },
    {
      label: intl.formatMessage({
        id: OPT_WORKFLOWS_LIST_TYPE_RECIPIENT_ACTIVITY
      }),
      value: OPT_WORKFLOWS_LIST_TYPE_RECIPIENT_ACTIVITY__VALUE
    },
    {
      label: intl.formatMessage({
        id: OPT_WORKFLOWS_LIST_TYPE_THANKS_FOR_JOIN
      }),
      value: OPT_WORKFLOWS_LIST_TYPE_THANKS_FOR_JOIN__VALUE
    },
    {
      label: intl.formatMessage({ id: OPT_WORKFLOWS_LIST_TYPE_ONBOARDING }),
      value: OPT_WORKFLOWS_LIST_TYPE_ONBOARDING__VALUE
    },
    {
      label: intl.formatMessage({ id: OPT_WORKFLOWS_LIST_TYPE_BIRTHDAY }),
      value: OPT_WORKFLOWS_LIST_TYPE_BIRTHDAY__VALUE
    },
    {
      label: intl.formatMessage({
        id: OPT_WORKFLOWS_LIST_TYPE_EVENT_REMINDERS
      }),
      value: OPT_WORKFLOWS_LIST_TYPE_EVENT_REMINDERS__VALUE
    },
    {
      label: intl.formatMessage({ id: OPT_WORKFLOWS_LIST_TYPE_ABANDONED_CART }),
      value: OPT_WORKFLOWS_LIST_TYPE_ABANDONED_CART__VALUE
    },
    {
      label: intl.formatMessage({ id: OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES }),
      value: OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES__VALUE
    },
    {
      label: intl.formatMessage({
        id: OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN
      }),
      value: OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE
    }
  ])

  const handleInputChange = (e) => {
    const val = e
    setSearchParams((prev) => ({
      ...prev,
      type: val
    }))
  }

  return (
    <Select
      searchable
      hintNoResults={intl.formatMessage({
        id: 'Load.Common.NoResultChosen'
      })}
      options={options}
      onChange={handleInputChange}
      value={type}
    />
  )
}

InputType.propTypes = {
  onChange: PropTypes.func
}
